/**
 * @description 商品 Code (enum)
 */
export enum ProductSidEnum {
  /** 預設 */
  Default = 'Default',
  /** 主首頁 */
  Home = 'Home',
  /** 旅平險 */
  Travel = 'T1',
  /** 小額險 */
  O1 = 'O1',
  /** 重大險 */
  D1 = 'D1',
  /** 壽險 */
  Life = 'L1',

  /** 定期壽險 */
  Life1 = 'Life1',

  Old = 'Old1',
  /** 重大險 */
  Disease = 'Disease1',
}
